import VueCalendar from './Components/VCalendar'
import VCalendarRange from './Components/VCalendarRange'
import VCalendarMultiple from './Components/VCalendarMultiple'

export default function (formulateInstance) {
	formulateInstance.extend({
		components: {
			VueCalendar,
			VCalendarRange,
			VCalendarMultiple
		},
		library: {
			// "calendar" and "vcalendar" and "v_calendar" cause problems
			// because this creates a new component with the key as the name
			vcal: {
				classification: 'date',
				component: 'VueCalendar'
			},
			vcal_range: {
				classification: 'date',
				component: 'VCalendarRange'
			},
			vcal_multiple: {
				classification: 'date',
				component: 'VCalendarMultiple'
			}
		}
	})
}
